
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Icons } from "@/components/ui/icons";
import { toast } from "sonner";

interface GoogleAuthButtonProps {
  onSuccess?: () => void;
  className?: string;
}

const GoogleAuthButton = ({ onSuccess, className }: GoogleAuthButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    
    try {
      // Get Google OAuth URL configuration
      const googleClientId = "533319905428-v8re8std8at5drm059tuk50drrnfcne5.apps.googleusercontent.com";
      const redirectUri = `${window.location.origin}/auth/google/callback`;
      const scope = "openid email profile https://www.googleapis.com/auth/calendar.events";
      const responseType = "code";
      const state = Math.random().toString(36).substring(2, 15);

      // Store state for validation
      sessionStorage.setItem('google_oauth_state', state);

      // Build Google OAuth URL
      const googleAuthUrl = new URL("https://accounts.google.com/o/oauth2/auth");
      googleAuthUrl.searchParams.append("client_id", googleClientId);
      googleAuthUrl.searchParams.append("redirect_uri", redirectUri);
      googleAuthUrl.searchParams.append("scope", scope);
      googleAuthUrl.searchParams.append("response_type", responseType);
      googleAuthUrl.searchParams.append("state", state);
      googleAuthUrl.searchParams.append("access_type", "offline");
      googleAuthUrl.searchParams.append("prompt", "consent");

      console.log('Redirecting to Google OAuth:', googleAuthUrl.toString());

      // Redirect to Google OAuth
      window.location.href = googleAuthUrl.toString();

    } catch (error) {
      console.error('Google login error:', error);
      toast.error('Erro ao iniciar login com Google');
      setIsLoading(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleGoogleLogin}
      disabled={isLoading}
      className={className}
    >
      {isLoading ? (
        <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <Icons.google className="mr-2 h-4 w-4" />
      )}
      Continuar com Google
    </Button>
  );
};

export default GoogleAuthButton;
